import React from "react";
import { Grid, Paper, Typography, Button } from "@mui/material";
import AttendeeMatches from "./AttendeeMatches";
import { EventContext } from "../../../contexts/EventContext";

import request from "../../../utilities/requests";

const MatchResults = () => {
  const { pairingEvent } = React.useContext(EventContext);
  const [attendeeMatches, setAttendeeMatches] = React.useState([]);
  const [matchRate, setMatchRate] = React.useState('');
  const [totalMatches, setTotalMatches] = React.useState('');
  const [statIndex, setStatIndex] = React.useState(0);
  const [view, setView] = React.useState("byAttendee");

  React.useEffect(() => {
    const id = setTimeout(() => {
      setStatIndex((i) => (i + 1) % 2);
    }, 6000);
    return () => clearTimeout(id);
  }, [statIndex]);

  const cycleStat = () => setStatIndex((i) => (i + 1) % 2);

  React.useEffect(() => {
    if (pairingEvent && attendeeMatches.length === 0) {
      getAttendeeMatches();
    }
  }, [attendeeMatches, pairingEvent]);

  const getAttendeeMatches = async () => {
    const result = await request(
      `pairingevent/attendeematches?pairingEventId=${pairingEvent._id}`
    );
    if (!result.success) {
      return;
    }
    setAttendeeMatches(result.attendeeMatches);
    setMatchRate(result.matchRate);
    setTotalMatches(result.totalMatches);
  };

  // const handleEmail = async () => {
  //   const body = {
  //     pairingEventId: pairingEvent._id,
  //   };

  //   const result = await request("pairingevent/sendmatchemails", "post", body);
  //   if (result.success) {
  //     alert("Match emails send successfully!");
  //   }
  // };

  return (
    <>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Grid container directioin="row" spacing={1}>
            <Grid item>
              <Typography style={{ padding: 10,fontWeight: 'bold' }}>Match Results</Typography>
            </Grid>
            <Grid item>
              <Typography
                onClick={cycleStat}
                style={{ padding: 10, cursor: "pointer", userSelect: "none" }}
              >
                {statIndex === 0
                  ? `Match Rate: ${matchRate}%`
                  : `Total Matches: ${totalMatches}`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={2}>
          <Button onClick={handleEmail}>Email</Button>
        </Grid> */}
      </Grid>
      {view === "byAttendee" ? (
        <AttendeeMatches data={attendeeMatches} />
      ) : (
        <Paper height={3} style={{ width: "100%" }}></Paper>
      )}
    </>
  );
};

export default MatchResults;
